"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelWhenVisible = cancelWhenVisible;
exports.whenVisible = whenVisible;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var VISIBLE_ROOT_MARGIN = '400px 0px';
var VISIBLE_ROOT_MARGIN_PX = 400;
var sharedVisibilityObserver = null;
var visibilityCallbacks = new WeakMap();

function isInVisibilityRange(target) {
  if (!target.isConnected || typeof globalThis.window === 'undefined') return false;
  var rect = target.getBoundingClientRect();
  return rect.bottom >= -VISIBLE_ROOT_MARGIN_PX && rect.top <= globalThis.window.innerHeight + VISIBLE_ROOT_MARGIN_PX;
}

var getVisibilityObserver = function getVisibilityObserver() {
  var _sharedVisibilityObse;

  if (typeof globalThis.window === 'undefined' || !('IntersectionObserver' in globalThis.window)) {
    return null;
  }

  (_sharedVisibilityObse = sharedVisibilityObserver) !== null && _sharedVisibilityObse !== void 0 ? _sharedVisibilityObse : sharedVisibilityObserver = new globalThis.window.IntersectionObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _sharedVisibilityObse2;

        var entry = _step.value;
        if (!entry.isIntersecting) continue;
        var _target = entry.target;
        var callback = visibilityCallbacks.get(_target);
        if (callback === undefined) continue;
        visibilityCallbacks.delete(_target);
        (_sharedVisibilityObse2 = sharedVisibilityObserver) === null || _sharedVisibilityObse2 === void 0 ? void 0 : _sharedVisibilityObse2.unobserve(_target);
        callback(_target);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    rootMargin: VISIBLE_ROOT_MARGIN
  });
  return sharedVisibilityObserver;
};

function whenVisible(target, callback) {
  if (isInVisibilityRange(target)) {
    callback(target);
    return false;
  }

  var observer = getVisibilityObserver();

  if (observer === null) {
    callback(target);
    return false;
  }

  if (visibilityCallbacks.has(target)) return true;
  visibilityCallbacks.set(target, callback);
  observer.observe(target);
  return true;
}

function cancelWhenVisible(target) {
  if (sharedVisibilityObserver === null) return;
  if (!visibilityCallbacks.has(target)) return;
  visibilityCallbacks.delete(target);
  sharedVisibilityObserver.unobserve(target);
}